import api from '../utils/api';
import { SubmissionError } from 'redux-form';
import { CATEGORY_FIELD } from '../components/GetQuotes/BaseForm';
import ActionTypes from '../constants/ActionTypes';

export const postJob = form => async dispatch => {
  const questions = transformQuestions(form);
  const formatted = massageData(questions);

  const { data } = await api.post('/api/job', formatted);

  if (data.errors) {
    throw new SubmissionError(data.errors);
  }
  try {
    if (data.job) {
      dispatch({ type: ActionTypes.POST_JOB_SUCCESS, payload: data.job });
      dispatch({ type: ActionTypes.HARD_REDIRECT_TO, payload: data.job.thankYouPageLink });
    }
  } catch (e) {
    throw e;
  }
};

export const massageData = data => ({
  ...data,
  [CATEGORY_FIELD]: data[CATEGORY_FIELD] && data[CATEGORY_FIELD].value,
  search_practice: data[CATEGORY_FIELD]
    ? data[CATEGORY_FIELD].parentValue || data[CATEGORY_FIELD].value
    : undefined,
  drilldown_cat_id:
    data[CATEGORY_FIELD] && data[CATEGORY_FIELD].parent ? data[CATEGORY_FIELD].value : undefined,
  category_id: data[CATEGORY_FIELD] ? data[CATEGORY_FIELD].id : undefined,
  session_id: +new Date(),
  origin_url: typeof window !== 'undefined' && window.location.hostname,
  start_by_details: data.start_by === '10' ? 'Other' : null
});

export const transformQuestions = data =>
  Object.keys(data).reduce((accum, key) => {
    if (key.includes('get_quotes_question') && Array.isArray(data[key])) {
      accum[key] = data[key].map((e, i) => e !== null && i).filter(Boolean);
    } else {
      accum[key] = data[key];
    }
    return accum;
  }, {});
